import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { BoardSection } from './subcomponents/BoardSection';
import { boardServices, cartServices, helpers, meetingServices, publicMinistryServices, userServices } from 'src/services';
import { BoardSideBar } from './subcomponents/BoardSideBar';
import { FailedToGetData, H2, Hr, Loading } from 'src/components/_commons';
import { pdfjs } from 'react-pdf';
import { setAlertResponse } from 'src/store';
import { typeBoardItemType, typeBoardSection, typeCartsDoc, typeMeetingsDoc, typePreachingGroup, typePublicMinistryDoc } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { useGetIsMobile } from 'src/custom-hooks';
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';

export const BoardPage = () => {
    const [cartsDoc, setCartsDoc] = useState<typeCartsDoc | null>(null);
    const [groups, setGroups] = useState<typePreachingGroup[] | null>(null);
    const [isLoading1, setIsLoading1] = useState(true);
    const [isLoading2, setIsLoading2] = useState(true);
    const [isLoading3, setIsLoading3] = useState(true);
    const [isLoading4, setIsLoading4] = useState(true);
    const [isLoading5, setIsLoading5] = useState(true);
    const [meetingsDoc, setMeetingsDoc] = useState<typeMeetingsDoc | null>(null);
    const [publicMinistryDoc, setPublicMinistryDoc] = useState<typePublicMinistryDoc | null>(null);
    const [sections, setSections] = useState<typeBoardSection[] | null>(null);
    const dispatch = useDispatch();
    const isMobile = useGetIsMobile();

    const currentSection: typeBoardSection | null = useMemo(() => {
        const relativePath = window.location.pathname;
        const _currentSection = sections?.find(i => `/tablero/${helpers.NormalizeString(i.title)}` === relativePath) ?? null;
        return _currentSection;
    }, [sections, window.location.pathname]);

    useEffect(() => {
        boardServices.Get().then(response => {
            setIsLoading1(false);
            if (!response.success || !response.data?.board) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setSections(response.data.board.sections);
        });
    }, []);

    useEffect(() => {
        const types: typeBoardItemType[] = ['avUshers', 'cleaning', 'midweekMeetings', 'publicMeetings'];
        if (!sections?.some(s => s.items.some(i => types.includes(i.type)))) {
            setIsLoading2(false);
            return;
        }
        setIsLoading2(true);
        meetingServices.Get().then(response => {
            setIsLoading2(false);
            if (!response.success || !response.data?.meetingsDoc) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setMeetingsDoc(response.data.meetingsDoc);
        });
    }, [sections]);

    useEffect(() => {
        if (!sections?.some(s => s.items.some(i => i.type === 'carts'))) {
            setIsLoading3(false);
            return;
        }
        setIsLoading3(true);
        cartServices.Get().then(response => {
            setIsLoading3(false);
            if (!response.success || !response.data?.cartsDoc) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setCartsDoc(response.data.cartsDoc);
        });
    }, [sections]);

    useEffect(() => {
        if (!sections?.some(s => s.items.some(i => i.type === 'groups'))) {
            setIsLoading4(false);
            return;
        }
        setIsLoading4(true);
        userServices.GetPreachingGroups().then(response => {
            setIsLoading4(false);
            if (!response.success || !response.data?.preachingGroups) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setGroups(response.data.preachingGroups);
        });
    }, [sections]);

    useEffect(() => {
        if (!sections?.some(s => s.items.some(i => i.type === 'publicMinistry'))) {
            setIsLoading5(false);
            return;
        }
        setIsLoading5(true);
        publicMinistryServices.Get().then(response => {
            setIsLoading5(false);
            if (!response.success || !response.data?.publicMinistryDoc) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setPublicMinistryDoc(response.data.publicMinistryDoc);
        });
    }, [sections]);

    if (isLoading1 || isLoading2 || isLoading3 || isLoading4 || isLoading5) {
        return <Loading mt={'120px'} />;
    }

    if (!sections) {
        return <FailedToGetData />;
    }

    if (!sections.length) {
        return (
            <div className={'mt-5'}>
                Aun no se crearon secciones
            </div>
        );
    }

    return (
        <div className={'row w-100 mx-auto'}>
            <div className={`col-lg-2 p-0 ${isMobile ? 'mt-3 w-75 mx-auto text-center' : ''}`}
                style={{ marginTop: '80px' }}
            >
                <BoardSideBar
                    currentSection={currentSection}
                    sections={sections}
                />
            </div>
            {isMobile &&
                <Hr classes={'mt-3 mb-0'} />
            }
            <div className={'col-lg-10'}>
                {!isMobile &&
                    <Hr styles={{ marginTop: '80px' }} />
                }
                {!currentSection?.title ?
                    <H2 title={'TABLERO'} mt={'30px'} />
                    :
                    <>
                    <H2 title={currentSection.title.toUpperCase()} mt={'30px'} />
                    <BoardSection
                        cartsDoc={cartsDoc}
                        groups={groups}
                        meetingsDoc={meetingsDoc}
                        publicMinistryDoc={publicMinistryDoc}
                        section={currentSection}
                    />
                    </>
                }
            </div>
        </div>
    );
}
